import { useState } from "react";

export function BoutonCopier({ texte }: { texte: string }) {
  const [etat, setEtat] = useState<"pret" | "copie" | "refuse">("pret");
  return (
    <button className="btn ghost sm" onClick={async () => {
      try { await navigator.clipboard.writeText(texte); setEtat("copie"); }
      catch { setEtat("refuse"); }
      setTimeout(() => setEtat("pret"), 1600);
    }}>
      {etat === "copie" ? "Copié" : etat === "refuse" ? "Copie refusée par le navigateur" : "Copier"}
    </button>
  );
}
